import {Action, getModule, Module, Mutation, VuexModule} from 'vuex-module-decorators';
import store from '@/store';

@Module({
    namespaced: true,
    name: 'mobile',
    store,
    dynamic: true,
})
class MobileModule extends VuexModule {
    public isMobileView: boolean = true;
    public androidUserAgent: RegExp = /Android/i;
    public iosUserAgent: RegExp = /iPhone|iPod|iPad/i;
    public androidAppUserAgent: RegExp = /app-pu-android|app-android/i;
    public iosAppUserAgent: RegExp = /app-pu-ios|app-ios/i;
    public androidOldAppUserAgent: RegExp = /app-pu-android/i;
    public iosOldAppUserAgent: RegExp = /app-pu-ios/i;
    public androidWfAppUserAgent: RegExp = /app-android/i;
    public iosWfAppUserAgent: RegExp = /app-ios/i;

    get isMobile(): boolean {
        return this.isMobileView;
    }

    get isAndroid(): boolean {
        return this.androidUserAgent.test(window.navigator.userAgent);
    }

    get isIos(): boolean {
        return this.iosUserAgent.test(window.navigator.userAgent);
    }

    get isAndroidApp(): boolean {
        return this.androidAppUserAgent.test(window.navigator.userAgent);
    }

    get isAndroidOldApp(): boolean {
        return this.androidOldAppUserAgent.test(window.navigator.userAgent);
    }

    get isAndroidWfApp(): boolean {
        return this.androidWfAppUserAgent.test(window.navigator.userAgent);
    }

    get isIosApp(): boolean {
        return this.iosAppUserAgent.test(window.navigator.userAgent);
    }

    get isIosOldApp(): boolean {
        return this.iosOldAppUserAgent.test(window.navigator.userAgent);
    }

    get isIosWfApp(): boolean {
        return this.iosWfAppUserAgent.test(window.navigator.userAgent);
    }

    get isApp(): boolean {
        return this.isAndroidApp || this.isIosApp;
    }

    @Mutation
    public setView(isMobile: boolean): void {
        this.isMobileView = isMobile;
    }

    @Action
    public detectMobile(): void {
        if (window.innerWidth < 768) {
            this.setView(true);
        } else {
            this.setView(false);
        }
    }

    @Action
    public updateMobileDetection(): void {
        window.addEventListener('onorientationchange', this.detectMobile);
        window.addEventListener('resize', this.detectMobile);
    }
}

export default getModule(MobileModule);
